import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Link from 'gatsby-link'
import onClickOutside from 'react-onclickoutside'
import Submenu from '../Submenu'
import './LinkItem.module.scss'

class LinkItem extends Component {
  state = {
    showSubmenu: false
  }

  handleClickOutside = (evt) => {
    this.setState({
      showSubmenu: false
    })
  }

  onClick = (e) => {
    e.preventDefault()
    const { click } = this.props

    click()

    this.setState({ showSubmenu: true })
  }

  render () {
    const { showSubmenu } = this.state
    const { allowSubmenu, item, index } = this.props
    const subMenu = R.prop('subMenu', item)
    const linkSlug = R.path(['link', 'slug'], item)
    const externalUrl = R.prop('externalLink', item)
    const title = R.prop('title', item)
    const hasSubmenu = allowSubmenu && subMenu
    return (
      <li key={`${linkSlug}-${index}`} styleName='item'>
        {hasSubmenu ? (
          <a href='#' styleName='link' onClick={this.onClick}>
            {title}
          </a>
        ) : (
          <span>
            {externalUrl ? (
              <Link to={externalUrl} styleName='link'>{title}</Link>
            ) : (
              <Link to={`/${linkSlug}`} styleName='link'>{title}</Link>
            )}
          </span>
        )}
        {hasSubmenu && <Submenu item={item} showSubmenu={showSubmenu} click={this.handleClickOutside} />}
      </li>
    )
  }
}

LinkItem.propTypes = {
  click: PropTypes.func,
  item: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  allowSubmenu: PropTypes.bool
}

LinkItem.defaultProps = {
  click: () => {},
  allowSubmenu: false
}

export default onClickOutside(LinkItem)



// WEBPACK FOOTER //
// ./src/components/PrimaryNavigation/LinkItem/LinkItem.js